import { supportsLocalStorage } from '../../app/utils/environment';
import { LOCAL_STORAGE_KEY } from '../../app/utils/persistentState';

/* Remove entries, i.e.
    {
        actionType: 'MY_ACTION'
        payload: 'VALUE'
    }
*/
let ENTRIES_TO_REMOVE = [];

/* Remove properties, i.e.
    {
        actionType: 'MY_ACTION', //added 2016-10-21
        property: 'VALUE'
    }
 */

export function setEntriesToRemove(param) {
    ENTRIES_TO_REMOVE = param;
}

export const removeOldEntries = (originalActions) => {
    let actions = Object.assign({}, originalActions);

    let foundEntriesToRemove = ENTRIES_TO_REMOVE.map((entryToRemove) => {
        return Object.keys(actions).find((actionType) => {
            return actionType === entryToRemove.actionType && actions[actionType].id === entryToRemove.id;
        });
    });

    foundEntriesToRemove.map((entry) => {
        if (entry !== undefined) {
            delete actions[entry];
        }
    });

    return actions;
};

// Actions created with a "persistent" flag (set to true) will be stored in local storage.
export const persistentState = (store) => (next) => (action) => {
    if (action.persistent === true && supportsLocalStorage()) {
        let actions = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY) || '{}');

        let newValue = action.payload;
        if (actions.hasOwnProperty(action.type)) {
            let original = actions[action.type];

            if (typeof original === 'object') {
                newValue = Object.assign({}, original, action.payload);
            }
        }

        actions[action.type] = newValue;

        //remove outdated stuff from localstorage e.g. after A/B tests
        actions = removeOldEntries(actions);

        window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(actions));
    }

    return next(action);
};

export default persistentState;
